export const toUrlString = (str?: string): string => {
	if (!str) {
		return "";
	}
	return str.split(" ").join("-").toLowerCase();
};

/**
 * Get the presentation URL for a given presentation title
 * @param presentationTitle The title of the presentation
 */
export const getPresentUrl = (presentationTitle: string): string => {
	return `/present/${toUrlString(presentationTitle)}`;
};
